import { Navigate, type RouteObject } from "react-router";
import StatusIndexRoute from "./status/status-index-route";
import { DeliveryIndexRoute } from "./_components/delivery-index-route";
import { SamplingMetadataIndexRoute } from "./sampling-data/sampling-metadata-index-route";
import { ActiveAirMicrobialIndexRoute } from "./active-air-mirobial/active-air-microbial-index-route";

export const deliveryRoutes: RouteObject[] = [
  {
    element: <DeliveryIndexRoute />,
    children: [
      {
        index: true,
        element: <Navigate to="status" />,
      },
      {
        path: "status",
        element: <StatusIndexRoute />,
      },
      {
        path: "sampling-metadata",
        element: <SamplingMetadataIndexRoute />,
      },
      {
        path: "active-air-microbial",
        element: <ActiveAirMicrobialIndexRoute />,
      },
    ],
  },
];
